<template>
  <div>
    <v-col class="col col-12" style="padding: 0">
      <v-card v-for="(res, b) in resp" :key="b" :color="hexColor">
        <div :class="{ additionalMargin: edulifeResponse.length > 1 }">
          <v-row>
            <div class="col-10">
              <v-card-title
                style="
                  word-break: break-word;
                  line-height: 1.5rem;
                  white-space: normal;
                  color: white;
                "
                v-text="title"
              ></v-card-title>
              <v-card-subtitle style="color: #f4f4f4">
                Inizio diretta oggi alle ore {{ oraEvento }}
              </v-card-subtitle>
              <v-card-actions style="color: white">
                <v-btn
                  v-if="res.status === true && isNotTooEarly(res)"
                  variant="text"
                  :href="res.join_url"
                  target="_blank"
                  style="color: white"
                  @click="logAccessFromLiveBox"
                >
                  Accedi alla diretta >
                </v-btn>
                <v-btn
                  v-else-if="res.status === true"
                  style="color: #f0f0f0"
                  variant="text"
                  disabled
                >
                  Evento non ancora iniziato
                </v-btn>
                <v-btn v-else variant="text" disabled> {{ res.msg }} </v-btn>
              </v-card-actions>
            </div>
            <div class="col-2 play-button-container">
              <span v-if="res.status === true && isNotTooEarly(res)">
                <svg-icon
                  type="mdi"
                  :path="path"
                  class="material-icons play-button"
                  :height="buttonDiameter"
                  :width="buttonDiameter"
                  @click="navigate_to(res.join_url)"
                ></svg-icon>
              </span>
              <span v-else class="material-icons play-button-early">
                <svg-icon
                  type="mdi"
                  :path="path"
                  class="material-icons play-button"
                  style="cursor: not-allowed"
                  :height="buttonDiameter"
                  :width="buttonDiameter"
                ></svg-icon>
              </span>
            </div>
          </v-row>
        </div>
      </v-card>
    </v-col>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiPlayCircleOutline } from '@mdi/js'

export default {
  name: 'BoxLinkDirettaCard',
  components: {
    SvgIcon,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    url: String,
    // eslint-disable-next-line vue/require-default-prop
    code: String,
    // eslint-disable-next-line vue/require-default-prop
    title: String,
    // eslint-disable-next-line vue/require-default-prop
    hexColor: String,
    // eslint-disable-next-line vue/require-default-prop
    oraEvento: String,
    // eslint-disable-next-line vue/require-default-prop
    contentId: Number,
  },
  data: () => ({
    path: mdiPlayCircleOutline,
    status: false,
    inizio: '',
    msg: '',
    resp: [],
    validLink: false,
    buttonDiameter: 60,
  }),
  computed: {
    edulifeResponse() {
      return this.resp
    },
  },
  mounted() {
    axios.get(this.url).then(eduResp => {
      this.resp = eduResp.data.data
    })
  },
  methods: {
    navigate_to(url) {
      this.logAccessFromLiveBox()
      window.open(url, '_blank')
    },
    isNotTooEarly(res) {
      const time_now = moment()
      const inizio = moment(res.inizio)
      return inizio.diff(time_now, 'minutes') < 30
    },
    logAccessFromLiveBox() {
      this.apiService.reservedAreaApi
        .logAccessFromLiveBox(this.contentId)
        .catch(err => {
          console.log(err.message)
        })
    },
  },
}
</script>
<style scoped>
*,
:after,
:before {
  box-sizing: border-box;
}
.additionalMargin {
  margin-bottom: 1rem;
}
.play-button,
.play-button-early {
  font-size: 40px;
  cursor: pointer;
  color: white;
}
.play-button-early {
  color: #ffffff4d;
}
.play-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
